import { render, staticRenderFns } from "./ConsumerDashboardBBPSpage.vue?vue&type=template&id=7894e759&scoped=true&"
import script from "./ConsumerDashboardBBPSpage.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardBBPSpage.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardBBPSpage.vue?vue&type=style&index=0&id=7894e759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894e759",
  null
  
)

export default component.exports